import React from 'react';

import { useLocation } from 'react-router-dom';
import { HTMLTemplate } from '@minerva-analytics/pantheon';

import { StyledCard, StyledDiv } from './Legal.styles';

const commonInfo = {
  dba: 'BackThenHistory',
  domain: 'www.backthenhistory.com',
  email: 'support@backthenhistory.com',
  name: 'BackThenHistory',
  address1: '1770 Massachusetts Ave #265',
  state: 'Cambridge, MA 02140',
  country: 'USA',
};

const legalInfo = {
  '/ccpa': {
    templateUrl: `https://storage.googleapis.com/minerva-legal/CalPolicy.html`,
    variables: { ...commonInfo },
  },
  '/cookie': {
    templateUrl: `https://storage.googleapis.com/minerva-legal/CookiePolicy.html`,
    variables: { ...commonInfo },
  },
  '/terms': {
    templateUrl: `https://storage.googleapis.com/minerva-legal/Terms.html`,
    variables: { ...commonInfo },
  },
  '/privacy': {
    templateUrl: `https://storage.googleapis.com/minerva-legal/Privacy.html`,
    variables: { ...commonInfo },
  },
};

const Legal = () => {
  const location = useLocation();

  return (
    <StyledDiv>
      <StyledCard>
        <HTMLTemplate {...legalInfo[location.pathname]} />
      </StyledCard>
    </StyledDiv>
  );
};

export default Legal;
